import { StackProps } from "@chakra-ui/react";
import { NewHireJourney } from "models/v2/newHireJourney";
import NewHireProfileCard from "./NewHireProfileCard";

interface NewHireHeaderProps extends StackProps {
  newHireJourney: NewHireJourney | undefined;
  includeLink?: boolean;
}

export default function NewHireHeader({ newHireJourney, includeLink = false, ...rest }: NewHireHeaderProps) {
  return (
    <NewHireProfileCard newHireJourney={newHireJourney} />
  );
}
